<div
  class="data-card border-b-2 bg-white py-8 grid grid-cols-1 md:grid-cols-3 relative px-5 lg:px-[100px] items-center"
>
  <span
    class="px-4 py-1 rounded-[20px] text-xs inline-flex items-center md:absolute left-4 cursor-pointer"
    [ngClass]="[
      cardConfig.paid ? 'bg-primary-100 text-primary' : 'bg-gray-200 text-grey'
    ]"
    (click)="presentMenuPopover($event, cardConfig.paid)"
  >
    PDF
    <ion-icon
      [name]="cardConfig.paid ? 'arrow-down-outline' : 'lock-closed-outline'"
      class="ml-2"
    ></ion-icon>
  </span>

  <h6 class="text-sm">{{ cardConfig.name }}</h6>
  <p class="text-sm">
    Born:
    <ion-text>24 July, 2005</ion-text>
  </p>
  <div class="flex items-center text-sm">
    <ion-icon name="pin-outline" size="24"></ion-icon>
    <ion-text class="ml-2">General Hospital Pankshin</ion-text>
  </div>
  <span class="card-more">
    <!-- <ion-text>View</ion-text> -->
    <ion-icon name="arrow-forward-outline" class="ml-2"></ion-icon>
  </span>
</div>
